import { useEffect, useState } from 'react';
import { getFunnelSessionCode } from '../../../utils/session';
import { logFunnelEvent } from '../../../utils/funnelEvents';
import { trackPixelEvent, trackPixelCustomEvent } from '../../../utils/metaPixel';

export default function WhatsAppContact() {
  const [isOpening, setIsOpening] = useState(false);

  useEffect(() => {
    logFunnelEvent({
      event_name: 'whatsapp_page_view',
      step_no: 5
    });

    trackPixelCustomEvent('WhatsAppPageView', {
      funnel_step: 5,
      importance: 12,
      content_name: 'WhatsApp İletişim Sayfası Görüntülendi'
    });
  }, []);

  const handleWhatsAppClick = async () => {
    if (isOpening) return;

    setIsOpening(true);

    try {
      await fetch('/api/funnel_kaydet.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          step: 'step5',
          oturum_kodu: getFunnelSessionCode()
        })
      });

      logFunnelEvent({
        event_name: 'whatsapp_click',
        step_no: 5
      });

      trackPixelEvent('Contact', {
        funnel_step: 5,
        importance: 13,
        content_name: 'WhatsApp Görüşmesi Başlatıldı'
      });

      trackPixelCustomEvent('WhatsAppClicked', {
        funnel_step: 5,
        importance: 13,
        content_name: 'WhatsApp Butonuna Tıklandı'
      });
    } catch (error) {
      console.error('Step 5 kayıt hatası:', error);

      trackPixelEvent('Contact', {
        funnel_step: 5,
        importance: 13,
        content_name: 'WhatsApp Görüşmesi Başlatıldı'
      });

      trackPixelCustomEvent('WhatsAppClicked', {
        funnel_step: 5,
        importance: 13,
        content_name: 'WhatsApp Butonuna Tıklandı'
      });
    }

    const whatsappNumber = '908508408383';
    const message = encodeURIComponent(
      'Merhaba , Smart Hizmet başvuru sürecini tamamladım ve işlemlerimin başlatılmasını talep ediyorum.'
    );

    setTimeout(() => {
      window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');

      setTimeout(() => {
        setIsOpening(false);
      }, 1000);
    }, 300);
  };

  return (
    <section className="min-h-screen flex items-center justify-center py-32 px-4 sm:px-6 lg:px-8 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black"></div>

      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-yellow-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div
          className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-green-500/10 rounded-full blur-3xl animate-pulse"
          style={{ animationDelay: '1s' }}
        ></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto w-full text-center">
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-green-500 rounded-full blur-2xl opacity-50 animate-pulse"></div>
            <div className="relative w-24 h-24 bg-gradient-to-br from-yellow-500 to-green-500 rounded-full flex items-center justify-center">
              <i className="ri-checkbox-circle-line text-5xl text-white"></i>
            </div>
          </div>
        </div>

        <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
          Başvurunuz <span className="bg-gradient-to-r from-yellow-500 to-green-500 bg-clip-text text-transparent">Alındı</span>
        </h2>

        <div className="bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 rounded-2xl p-8 sm:p-12 shadow-2xl shadow-yellow-500/10 mb-8">
          <p className="text-xl text-gray-300 mb-4 leading-relaxed">
            Başvurunuz incelendikten sonra sizin için uygun reklam planı hazırlanacaktır.
          </p>

          <p className="text-gray-400 text-base mb-6">
            Görüşme talebinizi iletmek için aşağıdaki WhatsApp butonuna tıklayabilirsiniz.
          </p>

          <div className="flex items-center justify-center gap-3 text-yellow-500 mb-8">
            <i className="ri-time-line text-2xl"></i>
            <span className="text-lg font-medium">Ortalama yanıt süresi: 24 saat</span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
            <div className="bg-black/30 border border-white/10 rounded-xl p-4">
              <i className="ri-user-star-line text-3xl text-yellow-500 mb-2"></i>
              <p className="text-white text-sm font-medium">Size Özel Reklam Planı</p>
            </div>
            <div className="bg-black/30 border border-white/10 rounded-xl p-4">
              <i className="ri-calendar-check-line text-3xl text-yellow-500 mb-2"></i>
              <p className="text-white text-sm font-medium">Sistem Yöneticisi ile Direkt Görüşme</p>
            </div>
            <div className="bg-black/30 border border-white/10 rounded-xl p-4">
              <i className="ri-shield-check-line text-3xl text-yellow-500 mb-2"></i>
              <p className="text-white text-sm font-medium">Yapay Zeka Destekli Reklam Sistemi</p>
            </div>
          </div>

          <button
            onClick={handleWhatsAppClick}
            disabled={isOpening}
            className={`w-full py-5 rounded-xl font-bold text-lg transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap ${
              !isOpening
                ? 'bg-gradient-to-r from-green-500 to-green-600 text-white hover:shadow-2xl hover:shadow-green-500/50 hover:scale-105 cursor-pointer'
                : 'bg-gray-700 text-gray-300 cursor-not-allowed'
            }`}
          >
            <i className="ri-whatsapp-line text-3xl"></i>
            <span>{isOpening ? 'WhatsApp Açılıyor...' : 'WhatsApp Görüşmesi Başlat'}</span>
          </button>

          <p className="text-gray-500 text-sm mt-4">
            Sistem yöneticimiz ile doğrudan iletişime geçin
          </p>
        </div>

        <div className="bg-gradient-to-r from-yellow-500/10 to-green-500/10 border border-yellow-500/30 rounded-xl p-6">
          <div className="flex items-start gap-4">
            <i className="ri-lightbulb-line text-2xl text-yellow-500 flex-shrink-0 mt-1"></i>
            <div className="text-left">
              <h3 className="text-white font-bold mb-2">Görüşme Öncesi Hazırlık</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                Görüşme sırasında işiniz hakkında daha detaylı bilgi paylaşmanız, size özel hazırlanacak reklam planının daha etkili olmasını sağlayacaktır.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}